import type { Goal } from "fhir/r4";
import { v4 as uuid } from "uuid";

import * as FHIRUtils from "../fhirutils";

export function buildFoodSecurityGoal(
  goalId: string | undefined,
  patientId: string,
  conditionId: string,
  updatedBy: string
): Goal {
  if (!goalId) {
    goalId = uuid();
  }

  const goal: Goal = {
    resourceType: "Goal",
    id: goalId,
    lifecycleStatus: "active",
    achievementStatus: {
      coding: [
        {
          system: "http://terminology.hl7.org/CodeSystem/goal-achievement",
          code: "in-progress",
          display: "In Progress",
        },
      ],
    },
    category: [
      {
        coding: [
          {
            system:
              "http://hl7.org/fhir/us/sdoh-clinicalcare/CodeSystem/SDOHCC-CodeSystemTemporaryCodes",
            code: "food-insecurity",
            display: "Food Insecurity",
          },
        ],
      },
    ],
    description: {
      coding: [
        {
          system: "http://snomed.info/sct",
          code: "1078229009",
          display: "Food security",
        },
      ],
    },
    subject: {
      reference: "Patient/" + patientId,
    },
    target: [
      {
        measure: {
          coding: [
            {
              system: "http://loinc.org",
              code: "88124-3",
              display: "Food insecurity risk [HVS]",
            },
          ],
        },
        detailCodeableConcept: {
          coding: [
            {
              system: "http://loinc.org",
              code: "LA19983-8",
              display: "No risk",
            },
          ],
        },
      },
    ],
    addresses: [
      {
        reference: "Condition/" + conditionId,
      },
    ],
  };

  return FHIRUtils.addUpdatedBy(goal, updatedBy);
}
